import { render, staticRenderFns } from "./ModuleIframe.vue?vue&type=template&id=29314bd4&scoped=true&"
import script from "./ModuleIframe.vue?vue&type=script&lang=ts&"
export * from "./ModuleIframe.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleIframe.vue?vue&type=style&index=0&id=29314bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29314bd4",
  null
  
)

export default component.exports